import { render, staticRenderFns } from "./commerce-authorization-dialog.vue?vue&type=template&id=1b9c63fe&"
import script from "./commerce-authorization-dialog.vue?vue&type=script&lang=js&"
export * from "./commerce-authorization-dialog.vue?vue&type=script&lang=js&"
import style0 from "./commerce-authorization-dialog.vue?vue&type=style&index=0&id=1b9c63fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports